module.exports = __webpack_public_path__ + "static/media/AB_K8_2.586b6e02.jpg";